/* Vedicos test — illustrations. One small scene per question: a face showing the feeling + a prop. */
var VD_ART = (function () {
  var INK = '#2b2330', SKIN = '#f5cba7', SKIN2 = '#efbd96', HAIR = '#3b2e3a', BRAND = '#b15cd6', SOFT = '#f4e9fb',
    GOLD = '#e0b85a', RED = '#e8695c', BLUE = '#79c3ee', GREY = '#bdb6c6', WHITE = '#ffffff';
  var C = { shirt: BRAND, soft: SOFT, accent: BRAND };
  var THEMES = {
    anxiety: { shirt: '#b9a5e8', soft: '#f3eefc', accent: '#7b62c4' },
    stress: { shirt: '#cdb291', soft: '#f7f0e8', accent: '#9a7350' },
    depression: { shirt: '#f4ae7e', soft: '#fff1e6', accent: '#e2733a' }
  };
  var ST = ' stroke="' + INK + '" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" fill="none"';

  function eyes(kind, look) {
    var dy = look === 'down' ? 2.5 : 0, dx = look === 'side' ? 2.5 : 0, s = '';
    [106, 134].forEach(function (x) {
      if (kind === 'wide') s += '<circle cx="' + x + '" cy="98" r="6.2" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="1.6"/><circle cx="' + (x + dx) + '" cy="' + (98 + dy) + '" r="2.9" fill="' + INK + '"/>';
      else if (kind === 'closed') s += '<path d="M' + (x - 6) + ' 98q6 5 12 0"' + ST + '/>';
      else if (kind === 'shut') s += '<path d="M' + (x - 6) + ' 99q6 -4 12 0"' + ST + '/>';
      else if (kind === 'droopy' || kind === 'tired') {
        s += '<circle cx="' + (x + dx) + '" cy="' + (100 + dy) + '" r="3.6" fill="' + INK + '"/><rect x="' + (x - 7) + '" y="92" width="14" height="7" fill="' + SKIN + '"/><path d="M' + (x - 6) + ' 99h12"' + ST + '/>';
        if (kind === 'tired') s += '<path d="M' + (x - 6) + ' 105q6 3 12 0" stroke="#d99f7c" stroke-width="2" stroke-linecap="round" fill="none"/>';
      } else s += '<circle cx="' + (x + dx) + '" cy="' + (98 + dy) + '" r="3.8" fill="' + INK + '"/>';
    });
    return s;
  }
  function brows(kind) {
    var d = {
      worried: 'M99 89 111 85M129 85 141 89',
      angry: 'M99 85 111 89M129 89 141 85',
      flat: 'M99 87h12M129 87h12',
      raised: 'M99 85q6-5 12-2M129 83q6-3 12 2',
      calm: 'M99 86q6-3 12 0M129 86q6-3 12 0'
    }[kind || 'calm'];
    return '<path d="' + d + '"' + ST + '/>';
  }
  function mouth(kind) {
    if (kind === 'open') return '<ellipse cx="120" cy="118" rx="5.5" ry="7" fill="' + INK + '"/>';
    if (kind === 'o') return '<circle cx="120" cy="117" r="3.6" fill="' + INK + '"/>';
    var d = {
      smile: 'M110 113q10 8 20 0',
      flat: 'M111 116h18',
      frown: 'M110 119q10-8 20 0',
      wavy: 'M108 116q3-3 6 0t6 0 6 0 6 0'
    }[kind || 'flat'];
    return '<path d="' + d + '"' + ST + '/>';
  }
  function person(f) {
    var s = '';
    s += '<path d="M62 180c2-30 25-44 58-44s56 14 58 44z" fill="' + C.shirt + '"/>';
    s += '<path d="M109 126h22v14c0 6-22 6-22 0z" fill="' + SKIN2 + '"/>';
    s += '<circle cx="82" cy="99" r="6.5" fill="' + SKIN2 + '"/><circle cx="158" cy="99" r="6.5" fill="' + SKIN2 + '"/>';
    s += '<circle cx="120" cy="94" r="38" fill="' + SKIN + '"/>';
    s += '<path d="M81 96c-4-30 12-48 39-48 26 0 42 16 39 46-3-10-9-17-17-21-10 6-26 9-44 6-6 4-11 9-17 17z" fill="' + HAIR + '"/>';
    s += eyes(f.eyes, f.look) + brows(f.brows) + mouth(f.mouth);
    if (f.blush) s += '<ellipse cx="98" cy="109" rx="6" ry="3.4" fill="#f28b9b" opacity=".45"/><ellipse cx="142" cy="109" rx="6" ry="3.4" fill="#f28b9b" opacity=".45"/>';
    if (f.sweat) s += '<path d="M160 68c-4 6-6 9-6 12a6 6 0 0 0 12 0c0-3-2-6-6-12z" fill="' + BLUE + '"/>';
    if (f.tear) s += '<path d="M104 105c-2.5 4-4 6-4 8a4 4 0 0 0 8 0c0-2-1.5-4-4-8z" fill="' + BLUE + '"/>';
    if (f.motion) s += '<path d="M66 78q-8 16 0 32M56 72q-13 22 0 44M174 78q8 16 0 32M184 72q13 22 0 44" stroke="' + GREY + '" stroke-width="3" stroke-linecap="round" fill="none"/>';
    if (f.tension) s += '<path d="M52 150l6-6 6 6 6-6 6 6M164 150l6-6 6 6 6-6 6 6" stroke="' + RED + '" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
    return s;
  }

  /* props */
  function cloud(x, y, sc, fill) {
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + sc + ')"><path d="M8 34A12 12 0 0 1 6 10a15 15 0 0 1 27-5 13 13 0 0 1 22 9 11 11 0 0 1-3 20z" fill="' + fill + '"/></g>';
  }
  function thought(inner) {
    return '<circle cx="160" cy="62" r="3.5" fill="' + WHITE + '" stroke="' + GREY + '" stroke-width="1.5"/><circle cx="168" cy="52" r="5" fill="' + WHITE + '" stroke="' + GREY + '" stroke-width="1.5"/>' +
      '<g transform="translate(162 4) scale(1.15)"><path d="M8 34A12 12 0 0 1 6 10a15 15 0 0 1 27-5 13 13 0 0 1 22 9 11 11 0 0 1-3 20z" fill="' + WHITE + '" stroke="' + GREY + '" stroke-width="1.4"/></g>' +
      '<g transform="translate(193 24)">' + (inner || '') + '</g>';
  }
  function spiral(color) { return '<path d="M0 0m-2 0a2 2 0 1 1 4 0a4.5 4.5 0 1 1-9 0a7 7 0 1 1 14 0a9.5 9.5 0 1 1-19 0" stroke="' + (color || C.accent) + '" stroke-width="2.2" fill="none" stroke-linecap="round"/>'; }
  function tangle(color) { return '<path d="M-14 -2c6-10 12 8 18-2s-12-8-8 2 14 6 16-2-10-10-14 0" stroke="' + (color || C.accent) + '" stroke-width="2.2" fill="none" stroke-linecap="round"/>'; }
  function moon(x, y) { return '<path d="M' + x + ' ' + y + 'a17 17 0 1 0 16 24 14 14 0 1 1-16-24z" fill="' + GOLD + '"/>' + star(x + 30, y + 2, 4) + star(x - 14, y + 30, 3); }
  function star(x, y, r) { return '<path d="M' + x + ' ' + (y - r) + 'q1 ' + (r - 1) + ' ' + r + ' ' + r + 'q-' + (r - 1) + ' 1-' + r + ' ' + r + 'q-1-' + (r - 1) + '-' + r + '-' + r + 'q' + (r - 1) + '-1 ' + r + '-' + r + 'z" fill="' + GOLD + '"/>'; }
  function clock(x, y, r, hour) {
    var a = (hour % 12) / 12 * Math.PI * 2, hx = x + Math.sin(a) * r * 0.5, hy = y - Math.cos(a) * r * 0.5;
    return '<circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.4"/>' +
      '<path d="M' + x + ' ' + y + 'L' + hx.toFixed(1) + ' ' + hy.toFixed(1) + 'M' + x + ' ' + y + 'L' + x + ' ' + (y - r * 0.72) + '"' + ST + '/>';
  }
  function battery(x, y) {
    return '<rect x="' + x + '" y="' + y + '" width="36" height="19" rx="4" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.4"/>' +
      '<rect x="' + (x + 36) + '" y="' + (y + 6) + '" width="4" height="7" rx="1.5" fill="' + INK + '"/><rect x="' + (x + 4) + '" y="' + (y + 4) + '" width="7" height="11" rx="2" fill="' + RED + '"/>';
  }
  function heart(x, y, sc, fill) { return '<g transform="translate(' + x + ' ' + y + ') scale(' + sc + ')"><path d="M12 21S0 14 0 6.5C0 1 6.5-1.5 12 4c5.5-5.5 12-3 12 2.5C24 14 12 21 12 21z" fill="' + fill + '"/></g>'; }
  function pulse(x, y, color) { return '<path d="M' + x + ' ' + y + 'h10l4-10 5 18 4-9h11" stroke="' + (color || RED) + '" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'; }
  function rain(x, y) { return cloud(x, y, 1.1, GREY) + '<path d="M' + (x + 14) + ' ' + (y + 44) + 'l-3 8M' + (x + 30) + ' ' + (y + 44) + 'l-3 8M' + (x + 46) + ' ' + (y + 44) + 'l-3 8" stroke="' + BLUE + '" stroke-width="2.6" stroke-linecap="round"/>'; }
  function bolt(x, y) { return '<path d="M' + (x + 10) + ' ' + y + 'L' + x + ' ' + (y + 17) + 'h8l-4 15 15-20h-9l5-12z" fill="#f2c14e" stroke="' + INK + '" stroke-width="1.6" stroke-linejoin="round"/>'; }
  function figure(x, y, sc) { return '<g transform="translate(' + x + ' ' + y + ') scale(' + sc + ')" fill="' + GREY + '"><circle cx="0" cy="0" r="9"/><path d="M-14 30c1-12 6-18 14-18s13 6 14 18z"/></g>'; }
  function plate(x, y) {
    return '<ellipse cx="' + x + '" cy="' + y + '" rx="24" ry="9" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.2"/><ellipse cx="' + x + '" cy="' + (y - 1) + '" rx="13" ry="4.5" fill="none" stroke="' + GREY + '" stroke-width="1.8"/>' +
      '<path d="M' + (x + 32) + ' ' + (y - 16) + 'v26M' + (x + 28) + ' ' + (y - 16) + 'v8q4 4 8 0v-8"' + ST + '/>';
  }
  function book(x, y) { return '<path d="M' + x + ' ' + y + 'q14-6 26 0v26q-12-6-26 0zM' + (x + 26) + ' ' + y + 'q12-6 26 0v26q-14-6-26 0z" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.2" stroke-linejoin="round"/>'; }
  function bed(x, y) { return '<rect x="' + x + '" y="' + (y + 10) + '" width="52" height="14" rx="3" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.2"/><rect x="' + (x + 4) + '" y="' + (y + 2) + '" width="14" height="9" rx="3" fill="' + SOFT + '" stroke="' + INK + '" stroke-width="2"/><path d="M' + x + ' ' + y + 'v30M' + (x + 52) + ' ' + (y + 14) + 'v16"' + ST + '/>'; }
  function door(x, y) { return '<rect x="' + x + '" y="' + y + '" width="30" height="50" rx="2" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2.4"/><circle cx="' + (x + 23) + '" cy="' + (y + 27) + '" r="2.4" fill="' + INK + '"/>'; }
  function papers(x, y) {
    var s = '';
    [[-8, 0], [4, -6], [-2, -12]].forEach(function (p, i) {
      s += '<g transform="translate(' + (x + p[1]) + ' ' + (y + p[1]) + ') rotate(' + p[0] + ')"><rect width="28" height="34" rx="2" fill="' + WHITE + '" stroke="' + INK + '" stroke-width="2"/><path d="M6 9h16M6 15h16M6 21h10" stroke="' + GREY + '" stroke-width="2" stroke-linecap="round"/></g>';
    });
    return s;
  }
  function wall(x, y) { return '<path d="M' + x + ' ' + (y + 14) + 'h26m-8-8 8 8-8 8"' + ST + '/><rect x="' + (x + 32) + '" y="' + (y - 6) + '" width="10" height="40" rx="2" fill="' + RED + '" opacity=".85"/>'; }
  function noteX(x, y) { return '<path d="M' + x + ' ' + (y + 22) + 'v-22l16-4v22" stroke="' + GREY + '" stroke-width="2.6" fill="none" stroke-linecap="round"/><circle cx="' + (x - 3) + '" cy="' + (y + 23) + '" r="4" fill="' + GREY + '"/><circle cx="' + (x + 13) + '" cy="' + (y + 19) + '" r="4" fill="' + GREY + '"/><path d="M' + (x - 8) + ' ' + (y - 6) + 'l30 34" stroke="' + RED + '" stroke-width="2.6" stroke-linecap="round"/>'; }
  function q(x, y, c) { return '<text x="' + x + '" y="' + y + '" font-family="Georgia,serif" font-size="22" font-weight="700" fill="' + (c || C.accent) + '">?</text>'; }
  function bang(x, y) { return '<text x="' + x + '" y="' + y + '" font-family="Georgia,serif" font-size="22" font-weight="700" fill="' + RED + '">!</text>'; }
  function sunrise(x, y) { return '<path d="M' + (x - 22) + ' ' + y + 'h44" stroke="' + INK + '" stroke-width="2.4" stroke-linecap="round"/><path d="M' + (x - 13) + ' ' + y + 'a13 13 0 0 1 26 0z" fill="' + GOLD + '"/><path d="M' + x + ' ' + (y - 20) + 'v-5M' + (x - 15) + ' ' + (y - 14) + 'l-4-4M' + (x + 15) + ' ' + (y - 14) + 'l4-4" stroke="' + GOLD + '" stroke-width="2.4" stroke-linecap="round"/>'; }
  function wavy(x, y) { return '<path d="M' + x + ' ' + y + 'q6-6 12 0t12 0 12 0M' + x + ' ' + (y + 10) + 'q6-6 12 0t12 0 12 0" stroke="' + C.accent + '" stroke-width="2.4" fill="none" stroke-linecap="round"/>'; }
  function crack(x, y) { return heart(x, y, 1.4, '#d9cde3') + '<path d="M' + (x + 17) + ' ' + (y + 6) + 'l-4 8 5 4-4 9" stroke="' + WHITE + '" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'; }
  function wilt(x, y) { return '<path d="M' + x + ' ' + (y + 40) + 'q2-22 10-28" stroke="#8aa36b" stroke-width="2.6" fill="none" stroke-linecap="round"/><g transform="translate(' + (x + 12) + ' ' + (y + 12) + ') rotate(40)"><ellipse cx="0" cy="-7" rx="5" ry="8" fill="#e9b7c9"/><ellipse cx="7" cy="2" rx="5" ry="8" fill="#e9b7c9" transform="rotate(70 7 2)"/><ellipse cx="-7" cy="2" rx="5" ry="8" fill="#e9b7c9" transform="rotate(-70 -7 2)"/><circle r="4" fill="' + GOLD + '"/></g>'; }
  function leaves() { return '<path d="M30 170c-4-26 10-40 30-44-2 22-12 36-30 44z" fill="#bfdca8"/><path d="M44 176c4-18 16-26 30-26-4 14-14 22-30 26z" fill="#d5e8c5"/><path d="M210 170c4-26-10-40-30-44 2 22 12 36 30 44z" fill="#bfdca8"/><path d="M196 176c-4-18-16-26-30-26 4 14 14 22 30 26z" fill="#d5e8c5"/>'; }
  function mini(icon) {
    var s = { work: '<rect x="-9" y="-6" width="18" height="13" rx="2" fill="' + GOLD + '"/><path d="M-4 -6v-3h8v3" stroke="' + INK + '" stroke-width="1.8" fill="none"/>', home: '<path d="M-9 1 0-8 9 1v8h-18z" fill="' + C.accent + '"/>', health: heart(-8, -8, 0.7, RED), money: '<circle r="8" fill="' + GOLD + '"/><text x="-3.5" y="4" font-size="11" font-weight="700" fill="' + INK + '">₹</text>' }[icon];
    return s;
  }

  var SCENES = {
    // Faceless, calm profile of a mother-to-be (pregnancy / breastfeeding page).
    expecting: function () {
      return '<circle cx="111" cy="40" r="21" fill="' + HAIR + '"/><circle cx="94" cy="28" r="10" fill="' + HAIR + '"/>' +
        '<path d="M113 60h13v13h-13z" fill="' + SKIN2 + '"/>' +
        '<circle cx="121" cy="44" r="18" fill="' + SKIN + '"/>' +
        '<path d="M103 45c-1-14 8-23 19-23 10 0 16 6 18 14-8-4-17-3-24 2-5 4-8 9-13 7z" fill="' + HAIR + '"/>' +
        '<path d="M126 48q4 3 8 0" stroke="' + INK + '" stroke-width="2.2" stroke-linecap="round" fill="none"/>' +
        '<path d="M98 76c9-7 31-7 40 0l5 24c24 10 33 39 16 60-7 9-19 14-37 14H100c-7-31-11-63-2-98z" fill="' + C.shirt + '"/>' +
        '<path d="M135 80c7 16 9 33 6 47" stroke="' + SKIN2 + '" stroke-width="10" stroke-linecap="round" fill="none"/>' +
        '<ellipse cx="146" cy="128" rx="9" ry="7" fill="' + SKIN + '"/>' +
        heart(164, 34, 0.85, '#f2a7a0') + star(70, 60, 5) + star(182, 84, 4) + leaves();
    },
    hero: function () { return leaves() + person({ brows: 'calm', eyes: 'closed', mouth: 'smile' }) + star(60, 52, 5) + star(182, 60, 4); },
    nervous: function () { return person({ brows: 'worried', eyes: 'wide', mouth: 'wavy', sweat: 1 }) + q(52, 70) + bang(178, 64); },
    loop: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'flat', look: 'side' }) + thought(spiral()); },
    worries: function () {
      return person({ brows: 'worried', eyes: 'open', mouth: 'frown' }) +
        [[48, 42, 'work'], [192, 40, 'home'], [40, 92, 'health'], [200, 96, 'money']].map(function (p) {
          return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="16" fill="' + WHITE + '" stroke="' + GREY + '" stroke-width="1.6"/><g transform="translate(' + p[0] + ' ' + p[1] + ')">' + mini(p[2]) + '</g>';
        }).join('');
    },
    tense: function () { return person({ brows: 'angry', eyes: 'shut', mouth: 'flat', tension: 1 }); },
    restless: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'wavy', motion: 1 }); },
    panic: function () { return person({ brows: 'raised', eyes: 'wide', mouth: 'open', sweat: 1 }) + bolt(40, 40) + bolt(186, 46); },
    heartbeat: function () { return person({ brows: 'worried', eyes: 'wide', mouth: 'o', sweat: 1 }) + heart(170, 104, 1.3, RED) + pulse(30, 80) ; },
    social: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'wavy', blush: 1, look: 'side' }) + figure(38, 120, 1) + figure(202, 116, 1.05) + figure(222, 132, 0.8); },
    sleepless: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'flat' }) + moon(36, 26) + thought('<text x="-9" y="5" font-size="16" font-weight="700" fill="' + C.accent + '">…</text>'); },
    drained: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'flat' }) + battery(180, 40); },
    nointerest: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'flat' }) + noteX(186, 36) + noteX(44, 50); },
    lowmood: function () { return person({ brows: 'worried', eyes: 'droopy', mouth: 'frown' }) + rain(88, -4); },
    sleepchange: function () { return person({ brows: 'worried', eyes: 'tired', mouth: 'flat' }) + moon(180, 22) + clock(48, 52, 17, 3); },
    lowenergy: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'frown' }) + battery(178, 40); },
    appetite: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'flat', look: 'down' }) + plate(186, 150) + q(176, 64); },
    selfdoubt: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'frown', look: 'down' }) + crack(178, 40); },
    focus: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'wavy', look: 'side' }) + book(166, 44) + '<g transform="translate(52 56)">' + spiral(GREY) + '</g>'; },
    heavy: function () { return person({ brows: 'worried', eyes: 'shut', mouth: 'frown', tear: 1 }) + cloud(150, 10, 1.1, '#d9d3e1') + wilt(36, 70); },
    motivation: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'flat' }) + bed(176, 40) + clock(52, 52, 16, 8); },
    withdraw: function () { return person({ brows: 'worried', eyes: 'shut', mouth: 'flat' }) + door(186, 20) + figure(44, 120, 0.9) + figure(28, 140, 0.7); },
    cantsleep: function () { return person({ brows: 'worried', eyes: 'wide', mouth: 'flat' }) + moon(176, 22) + clock(50, 54, 17, 1); },
    earlywake: function () { return person({ brows: 'worried', eyes: 'tired', mouth: 'flat' }) + clock(186, 46, 18, 4) + sunrise(52, 72); },
    tired: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'frown' }) + battery(178, 40); },
    uneasy: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'wavy' }) + wavy(172, 44) + wavy(34, 60); },
    overthink: function () { return person({ brows: 'worried', eyes: 'open', mouth: 'flat', look: 'side' }) + thought(tangle()); },
    time: function () { return person({ brows: 'angry', eyes: 'wide', mouth: 'wavy', sweat: 1 }) + clock(52, 50, 18, 11) + papers(176, 40); },
    blocked: function () { return person({ brows: 'angry', eyes: 'open', mouth: 'frown' }) + wall(166, 40); },
    overwhelmed: function () { return person({ brows: 'worried', eyes: 'wide', mouth: 'o', sweat: 1 }) + papers(176, 44) + papers(36, 30) + bolt(110, 2); },
    joyless: function () { return person({ brows: 'flat', eyes: 'droopy', mouth: 'flat' }) + heart(176, 40, 1.5, '#e4dceb') + noteX(46, 46); }
  };

  function scene(key) {
    var body = (SCENES[key] || SCENES.hero)();
    return '<svg viewBox="0 0 240 180" role="img" aria-hidden="true"><circle cx="120" cy="96" r="80" fill="' + C.soft + '"/>' + body + '</svg>';
  }

  // Small faces for the 4 answer options (calm → distressed).
  function optionFace(i) {
    var bg = ['#e3f4e1', '#fbf1d6', '#fde3cf', '#fbd7d7'][i];
    var f = [
      { brows: 'calm', eyes: 'open', mouth: 'smile' },
      { brows: 'flat', eyes: 'open', mouth: 'flat' },
      { brows: 'worried', eyes: 'open', mouth: 'frown' },
      { brows: 'worried', eyes: 'shut', mouth: 'wavy', sweat: 1 }
    ][i];
    var face = '<circle cx="120" cy="96" r="44" fill="' + SKIN + '"/>' + eyes(f.eyes) + brows(f.brows) + mouth(f.mouth) +
      (f.sweat ? '<path d="M158 70c-4 6-6 9-6 12a6 6 0 0 0 12 0c0-3-2-6-6-12z" fill="' + BLUE + '"/>' : '');
    return '<svg viewBox="66 42 108 108" width="34" height="34" aria-hidden="true"><circle cx="120" cy="96" r="54" fill="' + bg + '"/>' + face + '</svg>';
  }

  function setTheme(test) { var th = THEMES[test]; if (th) { C.shirt = th.shirt; C.soft = th.soft; C.accent = th.accent; } }

  return { scene: scene, optionFace: optionFace, setTheme: setTheme };
})();

/* Vedicos test — vedicos.in/pages/test?lid=… (Shopify).
 * One question per screen → "analysing" screen → your existing result page with ONLY ?lid=… in the link.
 * The answers reach the result page through this browser (localStorage) and the Worker backup.
 * Config: window.VD_TEST (set in the page template). Needs VD_ART (test-art.js, bundled before this).
 */
(function () {
  'use strict';

  var CFG = Object.assign({
    api: '',
    demo: false,
    chatUrl: '/pages/chat',
    resultUrls: { anxiety: '/pages/your-report', depression: '/pages/your-report', stress: '/pages/your-report' },
    metaPixel: '268791679288406'  // "Vedicos.in" dataset, vedicos business portfolio ('' = no browser Lead)
  }, window.VD_TEST || {});

  var LID_RE = /^vdc_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  var TESTS = ['anxiety', 'depression', 'stress'];
  var VALUES = ['Not at all', 'Somewhat', 'Moderately', 'A lot']; // what the result pages expect
  var OPTS = { en: VALUES, hi: ['Bilkul nahi', 'Thoda sa', 'Kaafi had tak', 'Bahut zyada'] };
  var AGE_VALUES = ['18-24', '25-34', '35-44', '45+'];  // 18+ only (we don't serve under 18)

  // [English, English hint, Hinglish, Hinglish hint, illustration]. Same order as the Fluent Forms tests.
  var Q = {
    anxiety: [
      ['Do you often feel nervous or anxious, even about small things?', 'For example: worrying about daily tasks or minor situations.', 'Kya aap aksar chhoti-chhoti baaton par bhi nervous ya anxious feel karte hain?', 'Jaise: roz ke kaam ya chhoti situations ko lekar fikar.', 'nervous'],
      ['Do you find it difficult to stop worrying once it starts?', 'Like your thoughts keep running even when you try to relax.', 'Ek baar fikar shuru ho jaye, toh kya use rokna mushkil lagta hai?', 'Jaise relax karne ki koshish karo, phir bhi dimaag mein khayal chalte rehte hain.', 'loop'],
      ['Do you worry too much about different areas of your life?', 'For example: work, health, relationships, or future.', 'Kya aap zindagi ki alag-alag cheezon ko lekar bahut zyada fikar karte hain?', 'Jaise: kaam, sehat, rishte ya future.', 'worries'],
      ['Do you struggle to relax even when there is no stress?', 'Like your mind or body feels tense without a clear reason.', 'Koi tension na ho, tab bhi kya relax karna mushkil lagta hai?', 'Jaise bina kisi wajah ke mann ya body mein tension rehti hai.', 'tense'],
      ['Do you feel restless or unable to stay calm?', 'Like you feel a strong urge to move and can’t sit still or relax.', 'Kya aap bechain rehte hain ya shaant nahi reh paate?', 'Jaise ek jagah tik kar baithna ya relax karna mushkil lagta hai.', 'restless'],
      ['Do you experience sudden feelings of fear or panic?', 'Even when there is no clear reason.', 'Kya achanak darr ya ghabrahat (panic) mehsoos hoti hai?', 'Tab bhi jab koi saaf wajah na ho.', 'panic'],
      ['Do you notice physical symptoms when feeling anxious?', 'Like fast heartbeat, sweating, trembling, or shortness of breath.', 'Anxious hone par kya body mein bhi kuch mehsoos hota hai?', 'Jaise tez dhadkan, paseena, kaanpna ya saans phoolna.', 'heartbeat'],
      ['Do you feel anxious in social situations?', 'Like worrying about being judged or embarrassed.', 'Kya logon ke beech jaane par anxiety hoti hai?', 'Jaise yeh fikar ki log judge karenge ya sharmindagi hogi.', 'social'],
      ['Do you have trouble sleeping due to overthinking?', 'Like your mind keeps thinking when you try to sleep.', 'Kya overthinking ki wajah se neend mein dikkat hoti hai?', 'Jaise sone ki koshish karo aur dimaag sochta hi rehta hai.', 'sleepless'],
      ['Do you feel mentally exhausted because of constant worry?', 'Like feeling drained even without doing much work.', 'Kya lagataar fikar ki wajah se aap mentally thak jaate hain?', 'Jaise zyada kaam kiye bina bhi thakaan mehsoos hona.', 'drained']
    ],
    depression: [
      ['Have you been feeling less interested in things you usually enjoy?', 'For example: watching movies, listening to music, or spending time with friends.', 'Kya jin cheezon mein pehle mazaa aata tha, unmein ab kam interest lagta hai?', 'Jaise: movies dekhna, gaane sunna ya doston ke saath time bitana.', 'nointerest'],
      ['Have you been feeling low, sad, or emotionally down?', 'For example: feeling hopeless or like things won’t improve.', 'Kya aap udaas, low ya emotionally down feel kar rahe hain?', 'Jaise: lagna ki kuch theek nahi hoga, koi ummeed nahi.', 'lowmood'],
      ['Have you been experiencing changes in your sleep?', 'For example: difficulty falling asleep, waking up often, or sleeping too much.', 'Kya aapki neend mein badlaav aaya hai?', 'Jaise: neend na aana, baar-baar aankh khulna ya bahut zyada sona.', 'sleepchange'],
      ['Have you been feeling low on energy or constantly tired?', 'Even if you haven’t done much physically.', 'Kya energy kam rehti hai ya hamesha thakaan lagti hai?', 'Bina zyada mehnat kiye bhi.', 'lowenergy'],
      ['Have you noticed changes in your eating habits?', 'For example: eating more or less than usual.', 'Kya aapke khaane ki aadat mein badlaav aaya hai?', 'Jaise: normal se zyada ya kam khaana.', 'appetite'],
      ['Have you been feeling bad about yourself?', 'For example: feeling like a failure or thinking you’ve let yourself or others down.', 'Kya aap apne baare mein bura feel karte hain?', 'Jaise: khud ko failure samajhna ya lagna ki aapne khud ko ya dusron ko niraash kiya.', 'selfdoubt'],
      ['Have you been finding it hard to concentrate?', 'For example: while reading, watching something, or working.', 'Kya dhyaan lagana (concentrate karna) mushkil ho raha hai?', 'Jaise: padhte, kuch dekhte ya kaam karte waqt.', 'focus'],
      ['Have you had thoughts that life is not worth living?', 'Or thoughts of harming yourself.', 'Kya kabhi aisa khayal aaya ki zindagi jeene layak nahi hai?', 'Ya khud ko nuksaan pahunchane ke khayal.', 'heavy'],
      ['Have you been struggling to stay motivated for daily activities?', 'For example: getting out of bed, bathing, or going to work/school.', 'Kya roz ke kaam karne ki himmat ya motivation nahi rehti?', 'Jaise: bistar se uthna, nahana ya kaam/school jaana.', 'motivation'],
      ['Have you been avoiding people or pulling away from others?', 'For example: not talking to friends or avoiding social situations.', 'Kya aap logon se doori bana rahe hain?', 'Jaise: doston se baat na karna ya logon se milne se bachna.', 'withdraw']
    ],
    stress: [
      ['Have you been finding it hard to fall asleep at night?', 'For example: lying in bed for a long time before finally sleeping.', 'Kya raat ko neend aane mein mushkil hoti hai?', 'Jaise: der tak bistar par lete rehna, tab jaake neend aana.', 'cantsleep'],
      ['Have you been waking up during the night or too early in the morning?', 'For example: waking up and not being able to fall asleep again.', 'Kya raat mein ya subah bahut jaldi neend khul jaati hai?', 'Jaise: aankh khulne ke baad dobara neend na aana.', 'earlywake'],
      ['Have you been feeling tired or low on energy most of the time?', 'For example: feeling exhausted even without doing much work.', 'Kya zyada tar time thakaan ya kam energy feel hoti hai?', 'Jaise: zyada kaam kiye bina bhi thak jaana.', 'tired'],
      ['Have you often been feeling worried, nervous, or uneasy without a clear reason?', 'For example: feeling mentally tense even when nothing specific is wrong.', 'Kya bina kisi saaf wajah ke fikar, ghabrahat ya bechaini rehti hai?', 'Jaise: kuch galat na ho, phir bhi mann mein tension.', 'uneasy'],
      ['Have you been overthinking a lot lately?', 'For example: replaying past events or worrying too much about the future.', 'Kya aajkal aap bahut zyada overthinking kar rahe hain?', 'Jaise: purani baatein baar-baar sochna ya future ki zyada fikar.', 'overthink'],
      ['Have you been feeling like there is never enough time to finish your work?', 'For example: always feeling rushed, delayed, or behind schedule.', 'Kya lagta hai ki kaam khatam karne ke liye time kabhi kaafi nahi hota?', 'Jaise: hamesha jaldbaazi, deri ya peeche rehne ka ehsaas.', 'time'],
      ['Have you been feeling like things are not going your way?', 'For example: feeling frustrated, unlucky, or blocked too often.', 'Kya lagta hai ki cheezein aapke hisaab se nahi chal rahi?', 'Jaise: baar-baar frustration, badkismati ya atka hua feel karna.', 'blocked'],
      ['Have your eating habits changed when you feel stressed or upset?', 'For example: eating too much or too little when under pressure.', 'Kya stress ya pareshani mein aapke khaane ki aadat badal jaati hai?', 'Jaise: pressure mein bahut zyada ya bahut kam khaana.', 'appetite'],
      ['Do unexpected situations make you feel easily overwhelmed?', 'For example: panicking or feeling mentally overloaded when plans suddenly change.', 'Kya achanak aayi situations se aap jaldi overwhelm ho jaate hain?', 'Jaise: plan achanak badalne par ghabra jaana ya dimaag par bojh lagna.', 'overwhelmed'],
      ['Have you been enjoying things less than before?', 'For example: losing interest in hobbies, social time, or usual daily activities.', 'Kya pehle jaisi cheezon mein ab kam mazaa aata hai?', 'Jaise: hobbies, doston ke saath time ya roz ke kaamon mein interest kam hona.', 'joyless']
    ]
  };

  // Same cut-offs as the live Shopify result pages (for the dashboard + WhatsApp only; the page decides what it shows).
  var STAGES = {
    anxiety: [[7, 'Minimal / None Anxiety', 'No pack needed right now'], [9, 'Mild Anxiety', '1 Month'], [14, 'Moderate Anxiety', '2 Months'],
      [18, 'Moderately Severe Anxiety', '3 Months'], [22, 'High Anxiety', '4 Months'], [26, 'Severe Anxiety', '5 Months'], [30, 'Extreme Anxiety', '6 Months']],
    depression: [[7, 'Symptom-Free', 'No pack needed right now'], [9, 'Mild Depression', '1 Month'], [14, 'Moderate Depression', '2 Months'],
      [18, 'Moderately Severe Depression', '3 Months'], [22, 'Severe Depression', '4 Months'], [26, 'Very Severe Depression', '5 Months'], [30, 'Extreme Depression', '6 Months']],
    stress: [[4, 'Minimal Stress', 'No pack needed right now'], [9, 'Mild Stress', 'No pack needed right now'], [14, 'Moderate Stress', '1 Month'],
      [19, 'Moderately Severe Stress', '2 Months'], [30, 'Severe Stress', '2 Months']]
  };

  var T = {
    en: {
      title: { anxiety: 'Anxiety Self-Check', depression: 'Depression Self-Check', stress: 'Stress Self-Check' },
      intro: '10 short questions about how you’ve felt over the last 2 weeks. It takes about 2 minutes. There are no right or wrong answers.',
      points: ['Designed by a team of mental health doctors', 'Private and free', 'Your personal report, instantly'],
      start: 'Start my self-check',
      choose: 'Which feels closest to you?',
      picks: { anxiety: 'Worry, panic or overthinking', depression: 'Low mood or no interest', stress: 'Pressure, tension or poor sleep' },
      name: 'What should we call you?', namePh: 'Your first name',
      age: 'How old are you?', ages: ['18–24', '25–34', '35–44', '45+'],
      gender: 'You are…', genders: [['Male', 'Male'], ['Female', 'Female']],
      qOf: function (i) { return 'Question ' + i + ' of 10'; },
      phone: 'Where should we send your report?', badName: 'Please enter your name',
      phoneSub: 'We’ll send your report link on WhatsApp. Our doctor may also reach out if needed.',
      phonePh: '10-digit WhatsApp number',
      badPhone: 'Please enter a valid 10-digit mobile number',
      consent: 'By continuing, you agree that Vedicos can contact you on WhatsApp or call about your result.',
      next: 'Continue',
      analysing: 'Analysing your answers',
      steps: ['Understanding your emotional patterns', 'Checking the effect on sleep and energy', 'Matching with Dr. Himmat’s care approach', 'Preparing your personal report'],
      care: 'If you ever feel unsafe, please call Tele-MANAS on 14416 (free, 24×7) or 112. You’re not alone 🤍',
      back: 'Back',
      preg: 'Are you pregnant or breastfeeding currently?', yes: 'Yes', no: 'No',
      stop: {
        hi: function (n) { return n ? 'Hi ' + n + ',' : 'Hi,'; },
        title: 'Please consult your doctor first',
        body: 'Since you’re pregnant or breastfeeding, we recommend speaking with your doctor or gynaecologist before starting any plan, including Ayurvedic medicines.',
        whyH: 'Why we pause here',
        why: [['🤰', 'Your and your baby’s safety comes first', 'Any medicine, Ayurvedic ones included, should be started only with your doctor’s guidance during this time.'],
              ['🌿', 'What you’re feeling is common', 'Feeling low, anxious or stressed during pregnancy or after delivery happens to many mothers. It’s okay to ask for help.'],
              ['🩺', 'Your doctor can guide you', 'They can suggest what is safe for you right now, including counselling or therapy.']],
        tipsH: 'Small things that can help right now',
        tips: ['Rest whenever you can and keep a regular sleep time', 'Share how you feel with someone you trust', 'Take a gentle walk or breathe slowly for a few minutes', 'Eat on time and drink enough water'],
        careT: 'If you ever feel unsafe or overwhelmed',
        careB: 'Call Tele-MANAS on 14416 (free, 24×7), or 112 in an emergency.',
        mistake: 'Selected this by mistake?', change: 'Change my answer',
        lock: 'Private'
      }
    },
    hi: {
      title: { anxiety: 'Anxiety Self-Check', depression: 'Depression Self-Check', stress: 'Stress Self-Check' },
      intro: 'Pichhle 2 hafton mein aap kaisa feel kar rahe hain, us par 10 chhote sawaal. Bas 2 minute lagenge. Koi sahi ya galat jawaab nahi hai.',
      points: ['Mental health doctors ki team dwara banaya gaya', 'Private aur free', 'Aapki personal report turant'],
      start: 'Mera self-check shuru karein',
      choose: 'Aapko sabse kareeb kya lagta hai?',
      picks: { anxiety: 'Fikar, ghabrahat ya overthinking', depression: 'Udaasi ya mann na lagna', stress: 'Pressure, tension ya neend ki dikkat' },
      name: 'Aapko kis naam se bulayein?', namePh: 'Aapka naam',
      age: 'Aapki umar kya hai?', ages: ['18–24', '25–34', '35–44', '45+'],
      gender: 'Aap…', genders: [['Male', 'Male'], ['Female', 'Female']],
      qOf: function (i) { return 'Sawaal ' + i + ' / 10'; },
      phone: 'Aapki report kahan bhejein?', badName: 'Please apna naam likhiye',
      phoneSub: 'Aapki report ka link WhatsApp par aayega. Zarurat ho toh hamare doctor bhi aapse baat kar sakte hain.',
      phonePh: '10 digit WhatsApp number',
      badPhone: 'Please 10 digit ka sahi mobile number likhiye',
      consent: 'Aage badhkar aap Vedicos ko apne result ke baare mein WhatsApp ya call par contact karne ki permission dete hain.',
      next: 'Aage badhein',
      analysing: 'Aapke jawaab analyse ho rahe hain',
      steps: ['Aapke emotional patterns samajh rahe hain', 'Neend aur energy par asar dekh rahe hain', 'Dr. Himmat ke care approach se match kar rahe hain', 'Aapki personal report tayaar ho rahi hai'],
      care: 'Agar kabhi bhi unsafe feel ho, toh Tele-MANAS 14416 (free, 24×7) ya 112 par call kijiye. Aap akele nahi hain 🤍',
      back: 'Peeche',
      preg: 'Kya aap abhi pregnant hain ya breastfeeding kara rahi hain?', yes: 'Haan', no: 'Nahi',
      stop: {
        hi: function (n) { return n ? 'Namaste ' + n + ',' : 'Namaste,'; },
        title: 'Pehle apne doctor se salah lijiye',
        body: 'Kyunki aap pregnant hain ya breastfeeding kara rahi hain, koi bhi plan shuru karne se pehle, Ayurvedic dawaiyon samet, apne doctor ya gynaecologist se baat zaroor kijiye.',
        whyH: 'Hum yahan kyun ruk rahe hain',
        why: [['🤰', 'Aapki aur aapke bachche ki safety sabse pehle', 'Is samay koi bhi dawai, Ayurvedic bhi, sirf doctor ki salah se hi shuru karni chahiye.'],
              ['🌿', 'Aap jo mehsoos kar rahi hain, woh aam hai', 'Pregnancy mein ya delivery ke baad udaasi, ghabrahat ya stress kai maaon ko hota hai. Madad maangna bilkul theek hai.'],
              ['🩺', 'Aapke doctor sahi raah dikhayenge', 'Woh bata sakte hain ki abhi aapke liye kya safe hai, jaise counselling ya therapy.']],
        tipsH: 'Abhi ke liye kuch chhoti baatein',
        tips: ['Jab ho sake aaram kijiye aur sone ka samay fix rakhiye', 'Apni baat kisi bharose wale insaan se share kijiye', 'Thodi der halki walk kijiye ya dheere-dheere saans lijiye', 'Samay par khaana khaiye aur paani peete rahiye'],
        careT: 'Agar kabhi bhi unsafe ya bahut bhaari lage',
        careB: 'Tele-MANAS 14416 (free, 24×7) par call kijiye, ya emergency mein 112.',
        mistake: 'Galti se select ho gaya?', change: 'Jawab badlein',
        lock: 'Private'
      }
    }
  };

  var app = document.getElementById('vt-app'), screen = document.getElementById('vt-screen'), fill = document.getElementById('vt-fill'),
    backBtn = document.getElementById('vt-back');
  if (!app || !screen) return;

  var J = { lid: '', lang: 'en', name: '', phone: '', hasPhone: false, test: '', age: '', gender: '', answers: [], src: {} };
  var flow = [], at = 0;

  function tt() { return T[J.lang] || T.en; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16);
    crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  function logEvent(event, extra) {
    var payload = Object.assign({ event: event, lead_id: J.lid, lang: J.lang, name: J.name, phone: J.phone, test: J.test, age: J.age, gender: J.gender }, J.src, extra || {});
    if (CFG.demo || !CFG.api) { if (window.console) console.log('[vedicos test] ' + event, payload); return Promise.resolve(); }
    try {
      return fetch(CFG.api + '/log', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload), keepalive: true })
        .catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }
  window.addEventListener('error', function (e) { if (J.lid && e && e.message) logEvent('client_error', { error: String(e.message).slice(0, 200) }); });

  /* ---------- Meta pixel: one "Lead" when the test is finished ---------- */
  // Shopify's Facebook app runs the same pixel on this page (on the page itself, not sandboxed). The layout
  // (vd-chat.liquid) queues autoConfig=false before Shopify's init, so Meta's automatic button-click and page-metadata
  // tracking is off here: it would otherwise send the answer labels. This script adds one "Lead" when the test is
  // finished (no test name, score or answers). The worker sends the same Lead to the Conversions API with the same
  // event id, so Meta counts it once.
  var FBEVENTS = 'https://connect.facebook.net/en_US/fbevents.js';
  function metaOk() {
    if (!CFG.metaPixel || CFG.demo || !CFG.api) return false;
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && typeof cp.marketingAllowed === 'function' && !cp.marketingAllowed()) return false; } catch (e) {}
    return true;
  }
  function metaLoad() {  // fbq queue only; Shopify's Facebook app loads fbevents.js (metaLead loads it if Shopify didn't)
    if (!metaOk() || metaLoad.done) return;
    metaLoad.done = true;
    !function (w) { if (w.fbq) return; var n = w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!w._fbq) w._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; }(window);
    window.fbq.disablePushState = true;
    window.fbq('set', 'autoConfig', false, CFG.metaPixel);  // only takes effect if it runs before init (the layout does that)
  }
  function metaScript() {
    if (document.querySelector('script[src="' + FBEVENTS + '"]')) return;
    var t = document.createElement('script'); t.async = true; t.src = FBEVENTS;
    (document.head || document.documentElement).appendChild(t);
  }
  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function metaLead(skip) {
    if (!metaOk() || !window.fbq) return {};
    try {
      var fbclid = J.src && J.src.fbclid;
      if (fbclid && !cookie('_fbc')) {  // the ad click id, saved by the chat, so the browser Lead keeps its ad
        document.cookie = '_fbc=' + encodeURIComponent('fb.1.' + (Date.parse(J.src.landed_at || '') || Date.now()) + '.' + fbclid) + '; path=/; max-age=7776000; SameSite=Lax';
      }
      if (!skip && !read('vd_meta_lead:' + J.lid)) {
        var me = { external_id: J.lid, country: 'in' }, ph = String(J.phone || '').replace(/\D/g, '');
        if (ph.length === 10) me.ph = '91' + ph;
        var fn = String(J.name || '').trim().split(/\s+/)[0].toLowerCase();
        if (fn) me.fn = fn;
        if (J.gender) me.ge = /^f/i.test(J.gender) ? 'f' : 'm';
        metaScript();
        window.fbq('set', 'userData', me);    // Shopify already ran init for this pixel, so the match keys go in here
        window.fbq('init', CFG.metaPixel, me); // no-op when Shopify's init ran; needed when Shopify's app is absent
        window.fbq('trackSingle', CFG.metaPixel, 'Lead', {}, { eventID: J.lid });
        store('vd_meta_lead:' + J.lid, '1');
      }
    } catch (e) {}
    return { fbp: cookie('_fbp'), fbc: cookie('_fbc') };
  }

  /* ---------- screens ---------- */

  function show(build, opts) {
    opts = opts || {};
    var view = el('div', 'vt-view');
    build(view);
    screen.innerHTML = '';
    screen.appendChild(view);
    screen.scrollTop = 0;
    window.scrollTo(0, 0);
    var counted = flow.filter(function (s) { return s.counted; }).length, done = flow.slice(0, at).filter(function (s) { return s.counted; }).length;
    fill.style.width = (counted ? Math.round(done * 100 / counted) : 0) + '%';
    backBtn.style.visibility = at > 0 && !opts.noBack ? 'visible' : 'hidden';
    app.classList.toggle('is-intro', !!opts.intro);
    app.classList.toggle('is-stop', !!opts.stop);
  }

  function go(i) { at = Math.max(0, Math.min(flow.length - 1, i)); flow[at].render(); }
  function next() { go(at + 1); }
  backBtn.addEventListener('click', function () { if (at > 0) go(at - 1); });

  function optionList(view, items, selected, onPick, opts) {
    opts = opts || {};
    var list = el('div', 'vt-opts' + (opts.grid ? ' vt-opts--grid' : ''));
    items.forEach(function (it, i) {
      var b = el('button', 'vt-opt' + (selected === it.v ? ' is-on' : ''));
      b.type = 'button';
      if (opts.faces) { var f = el('span', 'vt-face'); f.innerHTML = VD_ART.optionFace(i); b.appendChild(f); }
      b.appendChild(el('span', 'vt-opt-label', it.label));
      var tick = el('span', 'vt-tick'); tick.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="m9.5 16.6-4.1-4.1 1.4-1.4 2.7 2.7 7-7 1.4 1.4z"/></svg>';
      b.appendChild(tick);
      b.addEventListener('click', function () {
        if (list.classList.contains('is-locked')) return;
        if (!opts.stay) list.classList.add('is-locked');
        Array.prototype.forEach.call(list.children, function (c) { c.classList.remove('is-on'); });
        b.classList.add('is-on');
        setTimeout(function () { onPick(it.v); }, 230);
      });
      list.appendChild(b);
    });
    view.appendChild(list);
  }

  function introScreen() {
    show(function (v) {
      var art = el('div', 'vt-art vt-art--hero'); art.innerHTML = VD_ART.scene('hero'); v.appendChild(art);
      v.appendChild(el('h1', 'vt-title', tt().title[J.test]));
      v.appendChild(el('p', 'vt-lead', tt().intro));
      var ul = el('ul', 'vt-points');
      tt().points.forEach(function (p) { ul.appendChild(el('li', '', p)); });
      v.appendChild(ul);
      var b = el('button', 'vt-btn vt-btn--gold', tt().start + ' →'); b.type = 'button';
      b.addEventListener('click', next);
      v.appendChild(b);
      var langs = el('div', 'vt-langs');
      [['en', 'English'], ['hi', 'हिंदी']].forEach(function (l) {
        var lb = el('button', 'vt-langbtn' + (J.lang === l[0] ? ' is-on' : ''), l[1]); lb.type = 'button';
        lb.addEventListener('click', function () { J.lang = l[0]; introScreen(); });
        langs.appendChild(lb);
      });
      v.appendChild(langs);
    }, { intro: true, noBack: true });
  }

  function chooseScreen() {
    show(function (v) {
      v.appendChild(el('h2', 'vt-q', tt().choose));
      optionList(v, TESTS.map(function (k) { return { label: tt().picks[k], v: k }; }), J.test, function (k) {
        J.test = k;
        theme();
        logEvent('test_start');
        build();
        go(0);
      });
    }, { noBack: true });
  }

  function nameScreen() {
    show(function (v) {
      v.appendChild(el('h2', 'vt-q', tt().name));
      var inp = el('input', 'vt-input'); inp.type = 'text'; inp.autocomplete = 'given-name'; inp.maxLength = 40; inp.placeholder = tt().namePh; inp.value = J.name;
      v.appendChild(inp);
      var err = el('p', 'vt-err', ''); v.appendChild(err);
      var b = el('button', 'vt-btn', tt().next); b.type = 'button';
      var save = function () {
        var n = inp.value.replace(/[^A-Za-z\u0900-\u097F .']/g, '').replace(/\s+/g, ' ').trim();
        if (n.length < 2) { err.textContent = tt().badName; return; }
        J.name = n.charAt(0).toUpperCase() + n.slice(1);
        next();
      };
      b.addEventListener('click', save);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') save(); });
      v.appendChild(b);
      setTimeout(function () { inp.focus(); }, 50);
    });
  }

  function ageScreen() {
    show(function (v) {
      v.appendChild(el('h2', 'vt-q', tt().age));
      optionList(v, tt().ages.map(function (a, i) { return { label: a, v: AGE_VALUES[i] }; }), J.age, function (val) { J.age = val; next(); }, { grid: true });
    });
  }

  function genderScreen() {
    show(function (v) {
      v.appendChild(el('h2', 'vt-q', tt().gender));
      var preg = el('div', 'vt-preg');
      optionList(v, tt().genders.map(function (g) { return { label: g[0], v: g[1] }; }), J.gender, function (val) {
        J.gender = val;
        if (val === 'Female') askPregnancy(preg);
        else { J.pregnant = ''; preg.innerHTML = ''; next(); }
      }, { stay: true });
      v.appendChild(preg);
      if (J.gender === 'Female') askPregnancy(preg);
    });
  }

  // Shown on the same screen when "Female" is chosen. "Yes" stops the test (see stopScreen).
  function askPregnancy(box) {
    box.innerHTML = '';
    box.appendChild(el('h3', 'vt-q vt-q--sub', tt().preg));
    optionList(box, [{ label: tt().yes, v: 'yes' }, { label: tt().no, v: 'no' }], J.pregnant, function (val) {
      J.pregnant = val;
      if (val === 'yes') stopScreen(); else next();
    });
    setTimeout(function () { if (box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80);
  }

  function loadHeadFont() {
    if (document.getElementById('vt-josefin')) return;
    var l = document.createElement('link');
    l.id = 'vt-josefin'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@600;700&display=swap';
    document.head.appendChild(l);
  }

  // Pregnant or breastfeeding: no test, no plan. Just this page.
  function stopScreen() {
    var st = tt().stop, genderAt = at;
    loadHeadFont();
    logEvent('pregnancy_stop', { gender: 'Female' });
    show(function (v) {
      v.className += ' vt-stop';
      var hero = el('div', 'vt-stop-hero');
      hero.appendChild(el('span', 'vt-stop-lock', '🔒 ' + st.lock));
      hero.appendChild(el('p', 'vt-stop-hi', st.hi(J.name)));
      hero.appendChild(el('h1', 'vt-stop-h', st.title));
      v.appendChild(hero);
      var card = el('div', 'vt-stop-card');
      var art = el('div', 'vt-stop-art'); art.innerHTML = VD_ART.scene('expecting'); card.appendChild(art);
      card.appendChild(el('p', 'vt-stop-body', st.body));
      v.appendChild(card);
      v.appendChild(el('h2', 'vt-stop-sec', st.whyH));
      var why = el('div', 'vt-stop-why');
      st.why.forEach(function (w) {
        var row = el('div', 'vt-stop-row');
        row.appendChild(el('span', 'vt-stop-ic', w[0]));
        var txt = el('div', ''); txt.appendChild(el('b', '', w[1])); txt.appendChild(el('span', '', w[2]));
        row.appendChild(txt);
        why.appendChild(row);
      });
      v.appendChild(why);
      v.appendChild(el('h2', 'vt-stop-sec', st.tipsH));
      var tips = el('ul', 'vt-stop-tips');
      st.tips.forEach(function (x) { tips.appendChild(el('li', '', x)); });
      v.appendChild(tips);
      var care = el('div', 'vt-stop-care');
      care.appendChild(el('b', '', st.careT));
      care.appendChild(el('span', '', st.careB));
      var calls = el('div', 'vt-stop-calls');
      [['tel:14416', '📞 14416'], ['tel:112', '🚨 112']].forEach(function (c) { var a = el('a', '', c[1]); a.href = c[0]; calls.appendChild(a); });
      care.appendChild(calls);
      v.appendChild(care);
      var mis = el('p', 'vt-stop-mistake', st.mistake + ' ');
      var ch = el('button', '', st.change); ch.type = 'button';
      ch.addEventListener('click', function () { J.pregnant = ''; logEvent('pregnancy_changed'); go(genderAt); });
      mis.appendChild(ch);
      v.appendChild(mis);
    }, { noBack: true, stop: true });
  }

  function questionScreen(i) {
    var q = Q[J.test][i], en = J.lang === 'en';
    show(function (v) {
      var art = el('div', 'vt-art'); art.innerHTML = VD_ART.scene(q[4]); v.appendChild(art);
      v.appendChild(el('div', 'vt-kicker', tt().qOf(i + 1)));
      v.appendChild(el('h2', 'vt-q', en ? q[0] : q[2]));
      v.appendChild(el('p', 'vt-hint', en ? q[1] : q[3]));
      optionList(v, OPTS[en ? 'en' : 'hi'].map(function (label, k) { return { label: label, v: k }; }), J.answers[i], function (val) {
        J.answers[i] = val;
        next();
      }, { faces: true });
    });
  }

  function phoneScreen() {
    show(function (v) {
      var icon = el('div', 'vt-wa'); icon.innerHTML = '<svg viewBox="0 0 32 32" width="40" height="40"><circle cx="16" cy="16" r="16" fill="#25d366"/><path fill="#fff" d="M16 7.5a8.5 8.5 0 0 0-7.3 12.8L7.5 24.5l4.3-1.1A8.5 8.5 0 1 0 16 7.5zm4.9 11.9c-.2.6-1.2 1.1-1.7 1.2-.4 0-1 .1-3.2-.8-2.7-1.1-4.4-3.9-4.5-4.1-.1-.2-1.1-1.4-1.1-2.7s.7-1.9 1-2.2c.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .5l-.3.5-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.6-.1l1.8.9c.3.1.4.2.5.3.1.2.1.7-.1 1.2z"/></svg>';
      v.appendChild(icon);
      v.appendChild(el('h2', 'vt-q', tt().phone));
      v.appendChild(el('p', 'vt-hint', tt().phoneSub));
      var row = el('div', 'vt-phone');
      row.appendChild(el('span', 'vt-cc', '+91'));
      var inp = el('input', 'vt-input'); inp.type = 'tel'; inp.inputMode = 'numeric'; inp.autocomplete = 'tel-national'; inp.maxLength = 14; inp.placeholder = tt().phonePh; inp.value = J.phone;
      row.appendChild(inp);
      v.appendChild(row);
      var err = el('p', 'vt-err', ''); v.appendChild(err);
      v.appendChild(el('p', 'vt-small', tt().consent));
      var b = el('button', 'vt-btn', tt().next); b.type = 'button';
      var save = function () {
        var d = inp.value.replace(/\D/g, '');
        if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
        if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
        if (!/^[6-9]\d{9}$/.test(d)) { err.textContent = tt().badPhone; return; }
        J.phone = d;
        logEvent('phone');
        next();
      };
      b.addEventListener('click', save);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') save(); });
      v.appendChild(b);
      setTimeout(function () { inp.focus(); }, 50);
    });
  }

  function analysingScreen() {
    if (analysingScreen.done) return;  // a double tap / Enter + tap on the last screen must not finish the test twice
    analysingScreen.done = true;
    var score = J.answers.reduce(function (a, b) { return a + (b || 0); }, 0);
    var rows = STAGES[J.test], st = rows[rows.length - 1];
    for (var i = 0; i < rows.length; i++) if (score <= rows[i][0]) { st = rows[i]; break; }
    var result = { t: J.test, name: J.name, gender: J.gender, score: String(score) }, answers = {};
    J.answers.forEach(function (v, k) { result['q' + (k + 1)] = VALUES[v]; answers['q' + (k + 1)] = VALUES[v]; });
    store('vd_result:' + J.lid, JSON.stringify(result));
    if (J.name) store('ved_user_name', J.name);
    var selfHarm = J.test === 'depression' && J.answers[7] >= 1;
    var meta = metaLead(selfHarm);  // no Lead for self-harm answers (the worker skips them too)
    var sent = logEvent('test_done', Object.assign({ score: score, level: st[1], months: st[2], self_harm_flag: selfHarm ? 'yes' : 'no', answers: answers, result: result }, answers, meta));

    app.classList.add('is-analysing');
    show(function (v) {
      v.className += ' vt-analyse';
      v.appendChild(el('div', 'vt-ring'));
      v.appendChild(el('h2', 'vt-analyse-title', tt().analysing));
      var list = el('ul', 'vt-analyse-steps');
      tt().steps.forEach(function (s) { list.appendChild(el('li', '', s)); });
      v.appendChild(list);
      if (selfHarm) v.appendChild(el('p', 'vt-care', tt().care));
      Array.prototype.forEach.call(list.children, function (li, k) { setTimeout(function () { li.classList.add('is-done'); }, 700 * (k + 1)); });
    }, { noBack: true });

    var url = CFG.resultUrls[J.test] || CFG.resultUrls.anxiety;
    var minWait = selfHarm ? 6500 : 3400;
    Promise.all([wait(minWait), Promise.race([sent, wait(2500)])]).then(function () {
      location.replace(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'lid=' + encodeURIComponent(J.lid));
    });
  }

  function build() {
    flow = [{ render: introScreen }];
    if (!J.name) flow.push({ render: nameScreen, counted: true });
    flow.push({ render: ageScreen, counted: true }, { render: genderScreen, counted: true });
    for (var i = 0; i < 10; i++) (function (k) { flow.push({ render: function () { questionScreen(k); }, counted: true }); })(i);
    if (!J.phone) flow.push({ render: phoneScreen, counted: true });
    flow.push({ render: analysingScreen, counted: true });
  }

  /* ---------- start ---------- */

  function theme() { app.className = app.className.replace(/\s*theme-\w+/g, '') + (J.test ? ' theme-' + J.test : ''); if (window.VD_ART) VD_ART.setTheme(J.test); }

  function start() {
    metaLoad();
    if (TESTS.indexOf(J.test) < 0) { J.test = ''; chooseScreen(); return; }
    theme();
    logEvent('test_start');
    build();
    go(0);
  }

  var lid = new URLSearchParams(location.search).get('lid') || '';
  var journey = null;
  if (LID_RE.test(lid)) { try { journey = JSON.parse(read('vd_j:' + lid) || 'null'); } catch (e) {} }
  try { J.src = JSON.parse(read('vd_src') || '{}'); } catch (e) {}
  if (journey) {
    J.lid = lid; J.lang = journey.lang === 'hi' ? 'hi' : 'en'; J.name = journey.name || ''; J.phone = journey.phone || ''; J.test = journey.test || '';
    start();
  } else if (LID_RE.test(lid) && CFG.api && !CFG.demo) {
    J.lid = lid;
    fetch(CFG.api + '/lead?lid=' + encodeURIComponent(lid), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (d) { J.test = d.test || ''; J.lang = d.lang === 'hi' ? 'hi' : 'en'; J.name = d.name || ''; J.hasPhone = !!d.has_phone; start(); });
  } else {
    J.lid = LID_RE.test(lid) ? lid : 'vdc_' + uuid().toLowerCase();
    var p = new URLSearchParams(location.search);
    J.lang = p.get('lang') === 'hi' ? 'hi' : 'en';
    start();
  }
})();
